module.exports = __webpack_public_path__ + "media/images/emblems/Oberrueti-blason-a2af27b733bd8bf236ec10898e90b34d.png";